import { render, staticRenderFns } from "./MYOFFICE.vue?vue&type=template&id=650f855c&scoped=true&lang=pug"
import script from "./MYOFFICE.vue?vue&type=script&lang=js"
export * from "./MYOFFICE.vue?vue&type=script&lang=js"
import style0 from "./MYOFFICE.vue?vue&type=style&index=0&id=650f855c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f855c",
  null
  
)

export default component.exports